module.exports = __webpack_public_path__ + "fonts/dmsans-regular-webfont.28180f4.woff2";